<template>
  <div id="contact">
    <Header></Header>
    <ContactForm></ContactForm>
    <Footer></Footer>
  </div>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import ContactForm from "@/components/ContactForm.vue";

export default {
  name: "Contact",
  components: {
    Header,
    Footer,
    ContactForm
  }
};
</script>
